export default "__VITE_ASSET__$65Mj1tV__"